import { render, staticRenderFns } from "./WText.vue?vue&type=template&id=2caa3f85&"
import script from "./WText.vue?vue&type=script&lang=js&"
export * from "./WText.vue?vue&type=script&lang=js&"
import style0 from "./WText.vue?vue&type=style&index=0&id=2caa3f85&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports